import NotificationDeviceService from '@/services/retailer/NotificationDeviceService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  createNotificationDevice({}, notificationDevice) {
    return new Promise((resolve, reject) => {
      NotificationDeviceService.createNotificationDevice(notificationDevice)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
